import React from 'react';
import { createRoot } from 'react-dom/client';

import { Provider } from "react-redux"
import { store } from "./store/store"

import SentryComponent from "./functions/sentry.js"

import 'bulma/css/bulma.min.css';
import './index.css';

import "typeface-roboto";

import App from './App';
import reportWebVitals from './reportWebVitals';

import smoothscroll from 'smoothscroll-polyfill';
import AudioRecorder from 'audio-recorder-polyfill';
import 'url-search-params-polyfill';

window.MediaRecorder = AudioRecorder;
smoothscroll.polyfill();

<SentryComponent />

const container = document.getElementById('root');
const root = createRoot(container);


root.render(
  <Provider store={store}>
    {/* <React.StrictMode> */}
      <App />
    {/* </React.StrictMode> */}
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
